var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup72(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 100,
    viewBox: "0 0 118 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 72"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    x: 0.25,
    y: 0.25,
    width: 117,
    height: 99.5,
    rx: 4.75,
    fill: "#E5E7EB",
    stroke: "#9CA3AF",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "imagesmode"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_858_5865",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 40,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 49,
    y: 40,
    width: 19.5833,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_858_5865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "imagesmode_2",
    d: "M53.6575 56.5826C53.2902 56.5826 52.9798 56.4507 52.7262 56.1868C52.4725 55.9229 52.3457 55.6083 52.3457 55.2429V44.7558C52.3457 44.3904 52.4725 44.0757 52.7262 43.8118C52.9798 43.548 53.2902 43.416 53.6575 43.416H63.9262C64.2935 43.416 64.6039 43.548 64.8576 43.8118C65.1112 44.0757 65.238 44.3904 65.238 44.7558V55.2429C65.238 55.6083 65.1112 55.9229 64.8576 56.1868C64.6039 56.4507 64.2935 56.5826 63.9262 56.5826H53.6575ZM53.6575 55.4993H63.9262C63.989 55.4993 64.0465 55.4726 64.0988 55.4192C64.1511 55.3658 64.1773 55.307 64.1773 55.2429V44.7558C64.1773 44.6917 64.1511 44.6329 64.0988 44.5795C64.0465 44.526 63.989 44.4993 63.9262 44.4993H53.6575C53.5948 44.4993 53.5372 44.526 53.4849 44.5795C53.4326 44.6329 53.4064 44.6917 53.4064 44.7558V55.2429C53.4064 55.307 53.4326 55.3658 53.4849 55.4192C53.5372 55.4726 53.5948 55.4993 53.6575 55.4993ZM55.6536 53.791H61.9969C62.1282 53.791 62.2226 53.7295 62.2801 53.6067C62.3376 53.4838 62.3267 53.3652 62.2472 53.2509L60.3422 50.6516C60.276 50.5512 60.1913 50.501 60.088 50.501C59.9847 50.501 59.9 50.5512 59.8338 50.6516L58.0418 53.0154L57.0313 51.7237C56.9651 51.6286 56.8817 51.5811 56.781 51.5811C56.6803 51.5811 56.5969 51.6313 56.5307 51.7317L55.4109 53.2515C55.3237 53.3654 55.3106 53.4838 55.3715 53.6067C55.4324 53.7295 55.5265 53.791 55.6536 53.791ZM55.8544 47.791C56.0688 47.791 56.2516 47.7138 56.4028 47.5594C56.5539 47.405 56.6295 47.2183 56.6295 46.9993C56.6295 46.7803 56.5539 46.5936 56.4028 46.4392C56.2516 46.2849 56.0688 46.2077 55.8544 46.2077C55.6399 46.2077 55.4571 46.2849 55.3059 46.4392C55.1548 46.5936 55.0792 46.7803 55.0792 46.9993C55.0792 47.2183 55.1548 47.405 55.3059 47.5594C55.4571 47.7138 55.6399 47.791 55.8544 47.791Z",
    fill: "#6B7280"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup72);
export default __webpack_public_path__ + "static/media/Group 72.cebcbebebd136784d4efb6deebf3bbd1.svg";
export { ForwardRef as ReactComponent };